import React, { useCallback, useState } from 'react'
import { Button, Card, Form, Modal, Table } from 'react-bootstrap'
import callApi from '../../../helpers/callAPI'
import useCallApi from '../../../hooks/useCallApi'
import AffiliateNavbar from '../../../pages/Affiliate/Templates/AffiliateNavbar/AffiliateNavbar'
import Affiliate from '../../../templates/Affiliate/Affiliate'
import Campaign from '../../../templates/Campaign/Campaign'
import Loading from '../../../templates/UI/Loading/Loading'
import ReportTable from '../../../templates/ReportTable/ReportTable'
import CampaignNavbar from '../../../pages/Campaign/CampaignNavBar/CampaignNavBar'
import { useAuth, useProtectedPage } from '../../../context/AuthContext'
import { useRef } from 'react'
import Advertiser from '../../../templates/Advertiser/Advertiser'
import moment from 'moment'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'

const OutstandingInvoices = ({ affiliateId, campaignId, showSystemMessage }) => {
  const auth = useAuth()
  useProtectedPage(auth.permissions, 'avatar')

  const scrubThresholdRef = useRef([])
  const scrubRateRef = useRef([])

  const [isOpen, setIsOpen] = useState(false)

  const { dataLoaded, data, setData, refetch } = useCallApi('advertisers/outstandingInvoices', 'GET', {}, [])

  if (dataLoaded && affiliateId) {
    document.title = `${data.affiliate.name}: Avatar Scrub Overrides`
  } else if (dataLoaded && campaignId) {
    document.title = `${data.campaign.name}: Avatar Scrub Overrides`
  } else {
    document.title = `Avatar Scrub Overrides`
  }
  //m.merchant_id, inv.invoice_num,inv.invoice_date, inv.status, inv.sent_date, inv.period_start, inv.period_end, inv.amount, inv.notes
  const getReportOutput = () => {
    let columns = [
      {
        Header: 'Advertiser ID',
        accessor: 'merchant_id',
        Cell: ({ cell: { value } }) => {
          return <>{value}</>
        },
      },
      {
        Header: 'Advertiser Name',
        accessor: 'name',
        Cell: (tableData) => {
          return <Advertiser name={tableData.data[tableData.row.index].name} id={tableData.data[tableData.row.index].merchant_id} />
        }        
      },
      {
        Header: 'Invoice ID',
        accessor: 'invoice_num',
        Cell: ({ cell: { value } }) => {
          return <>{value}</>
        },
      },
      {
        Header: 'Invoice Date',
        accessor: 'invoice_date',
        Cell: ({ cell: { value } }) => {
          return <>{value ? moment(value).format('YYYY-MM-DD') : 'N/A'}</>
        },
      },
      {
        Header: 'Sent Date',
        accessor: 'sent_date',
        Cell: ({ cell: { value } }) => {
          return <>{value ? moment(value).format('YYYY-MM-DD') : 'N/A'}</>
        },
      },
      {
        Header: 'Period Start',
        accessor: 'period_start',
        Cell: ({ cell: { value } }) => {
          return <>{value ? moment(value).format('YYYY-MM-DD') : 'N/A'}</>
        },
      },
      {
        Header: 'Period End',
        accessor: 'period_end',
        Cell: ({ cell: { value } }) => {
          return <>{value ? moment(value).format('YYYY-MM-DD') : 'N/A'}</>
        },
      },
      {
        Header: 'Amount',
        accessor: 'amount',
        Cell: ({ cell: { value } }) => {
          return <>{value}</>
        },
      },
      {
        Header: 'Notes',
        accessor: 'notes',
        Cell: ({ cell: { value } }) => {
          return <>{value}</>
        },
      },
      {
        Header: 'Due Date',
        accessor: 'due_date',
        Cell: ({ cell: { value } }) => {
          return <>{value ? moment(value).format('YYYY-MM-DD') : 'N/A'}</>
        },
      },
      {
        Header: 'Affiliates Report',
        Cell: ({ cell: { value } }) => {
          return <><Link to={`/reports/stats/affiliates?`} target="_blank" rel="noreferrer">View Report</Link></>
        },
      }

    ]

    return (
      <React.Fragment>
        <ReportTable
          data={data.data}
          columns={columns}
        />
      </React.Fragment>
    )
  }

  return (
    <div>
      <div className="page-header d-flex align-items-center">
        <h1 className="mb-h1">Outstanding Invoices</h1>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <Card>
            <Card.Body className="p-0">

              {dataLoaded ? data.data.length === 0 ? <div className="p-3">No stats for the current parameters.</div> : getReportOutput() : <Loading></Loading>}
            </Card.Body>
          </Card>
        </div>
      </div>
    </div>
  )
}

export default OutstandingInvoices